import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import styles from "./DivEditable.module.scss";
import { domSanitizeAndUrlify } from "../../../utils/helper";
const DivEditable = _ref => {
  let {
    html,
    onKeyDown,
    index,
    onChange,
    divElementRef,
    isChecked,
    updateLastUpdatedRef,
    updateTodoOnlyIfEmpty
  } = _ref;
  const emitChange = event => {
    updateTodoOnlyIfEmpty(event, index);
    updateLastUpdatedRef(index);
  };
  const divOnBlur = event => {
    onChange(event, index);
  };
  return /*#__PURE__*/React.createElement("div", {
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML: {
      __html: domSanitizeAndUrlify(html)
    },
    ref: divElementRef,
    key: index,
    contentEditable: true,
    className: cx(styles.todoContent, {
      [styles.textUnderLine]: isChecked
    }),
    id: index,
    role: "textbox",
    onInput: emitChange,
    onBlur: divOnBlur,
    onKeyDown: onKeyDown
  });
};
export default DivEditable;
DivEditable.propTypes = {
  divElementRef: PropTypes.object.isRequired,
  html: PropTypes.string.isRequired,
  index: PropTypes.string.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
};